module.exports = __webpack_public_path__ + "img/icon_total_medal.322e23ee.png";